var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!../../../opt/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader?{\"sourceMap\":false}!css-loader?{\"sourceMap\":false,\"minimize\":true,\"importLoaders\":0,\"alias\":{\"/assets\":\"/app/assets\",\"/static\":\"/app/static\"}}!../../../opt/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-41c071cf\",\"scoped\":false,\"hasInlineConfig\":true}!../../../opt/node_modules/vue-loader/lib/selector?type=styles&index=0!./nuxt-loading.vue")
}
var normalizeComponent = require("!../../../opt/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader?{\"babelrc\":false,\"cacheDirectory\":false,\"presets\":[[\"/opt/node_modules/babel-preset-vue-app/dist/index.common.js\",{\"targets\":{\"ie\":9,\"uglify\":true}}]]}!../../../opt/node_modules/vue-loader/lib/selector?type=script&index=0!./nuxt-loading.vue"
import __vue_script__ from "!!babel-loader?{\"babelrc\":false,\"cacheDirectory\":false,\"presets\":[[\"/opt/node_modules/babel-preset-vue-app/dist/index.common.js\",{\"targets\":{\"ie\":9,\"uglify\":true}}]]}!../../../opt/node_modules/vue-loader/lib/selector?type=script&index=0!./nuxt-loading.vue"
/* template */
import __vue_template__ from "!!../../../opt/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-41c071cf\",\"hasScoped\":false,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"object\":\"src\",\"embed\":\"src\"},\"preserveWhitespace\":false,\"buble\":{\"transforms\":{}}}!../../../opt/node_modules/vue-loader/lib/selector?type=template&index=0!./nuxt-loading.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = ".nuxt/components/nuxt-loading.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-41c071cf", Component.options)
  } else {
    hotAPI.reload("data-v-41c071cf", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./.nuxt/components/nuxt-loading.vue
// module id = F88d
// module chunks = 28